<template>
  <div class="login" @click="() => $listeners.onOff(false)">
    <div class="pop_up_window_content" @click.stop="() => null">
      <div class="left_img">
        <div class="header">
          <img :src="require('@/assets/images/public/login_background.png')">
        </div>
        <div class="text_content">PES平台依托跨语言、跨专业的数据关联与过滤技术，基于先进国际工程项目管理内专业逻辑，通过建立全球数据源的合作关系精准定位并获取技术标准以及相关国际电力工程最佳实践等专业技术信息数据，对其进行归纳、关联，并实时动态更新管理，并在国际电力工程项目管理各个环节中，客观呈现相互之间在技术、商务、管理领域中多维度关联关系。</div>
      </div>
      <div class="right_form">
        <LoginForm v-if="$store.state.loginStatus" />
        <SignForm v-if="!$store.state.loginStatus" />
      </div>
    </div>
  </div>
</template>

<script>
import LoginForm from './loginForm';
import SignForm from './signForm';
export default {
  components: { LoginForm, SignForm },
  props: {
    submit: { type: Function, }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>